module.exports = __webpack_public_path__ + "static/img/no-address.264e863.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-address.svg
// module id = kNkO
// module chunks = 0